module.exports = __webpack_public_path__ + "img/enston.671c01bf.png";